<div class="export-button-container text-right mb-3">
  <button type="button"
          pRipple
          icon="pi pi-file-excel"
          class="p-button-success"
          pTooltip="{{ 'TOOLS.EXPORTXLS' | translate }}"
          tooltipPosition="bottom"
          (click)="exportToExcel()">
    EXPORT XLS
  </button>
</div>

<h3 class="text-center">
Classement of competition :  {{ competition.startDate  }} - {{ competition.endDate }}

</h3>
<div class="report-table">
 
    

  
  
    <table class="styled-table">
      <thead>
        <tr>
          <th>User ID</th>
          <th>Phone number</th>
          <th>Total Steps</th>
          <th>Total Distance (m)</th>
          <th>Total Points</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of filteredAndSortedReports">
          <td>{{ report.userId }}</td>
          <td>{{ report.phoneNumber }}</td>
          <td>{{ report.steps }}</td>
          <td>{{ report.distance }}</td>
          <td>{{ report.numberOfPoints }}</td>
        </tr>
      </tbody>
    </table>
  </div>